import React, { Component } from 'react'
import styles from './styles.scss'
import { PagesResource } from '@/resources'

/** Components */
import Loading from '@/components/Loading'

import { rawElementFactory } from '@/components/commons/editor/EditorFactory'
import IconComponent from '@/components/commons/IconComponent'
import { connect } from 'react-redux'
import { getTranslation } from '../../../../store/getters/language'

class MagazineCover extends Component {
  state = {
    loading: true,
    hasPages: true,
    elements: [],
    pageBackground: {}
  }

  componentDidMount() {
    PagesResource.fetchAll({
      params: {
        where: `id_magazine=${this.props.magazineID} order by page_position`,
        limit: 1
      }
    }).then(({ data }) => {
      const [pageContent] = data
      this.parse(pageContent)
    })
  }

  /**
   * Parse elements
   * @param {Array} content
   */
  parse = content => {
    if (!content) {
      this.setState({
        loading: false,
        hasPages: false
      })
      return
    }
    const rawItems = content.items.map(item => {
      const content = JSON.parse(item.content)
      return { __html: rawElementFactory(content, 0.618, true) }
    })
    const { properties } = content

    this.setState({
      elements: rawItems,
      loading: false,
      pageBackground: properties ? JSON.parse(properties) : {}
    })
  }

  render() {
    const { translation } = this.props
    const { elements, pageBackground } = this.state

    return (
      <div className={styles['wrapper-magazine-cover']}>
        <div
          className={styles['wrapper-magazine-cover__content']}
          style={pageBackground}
        >
          {this.state.loading ? (
            <Loading />
          ) : (
            !!elements.length ? (
              elements.map((item, index) => (
                <div className={'internal-no-fonts'} key={index} dangerouslySetInnerHTML={item} />
              ))
            ) : (
              <div className={styles['wrapper-magazine-cover__content-blank']}>
                <IconComponent icon="magazine" />
                <span>{translation('general-in-blank')}</span>
              </div>
            )
          )}
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const translation = getTranslation(state)
  return { translation }
}

export default connect(mapStateToProps)(MagazineCover)



// WEBPACK FOOTER //
// ./src/pages/Dashboard/components/MagazineCover/index.js